import { createClient } from "@supabase/supabase-js";

var SUPABASE_URL = "https://ixyfmxgxfpuapxvyoumy.supabase.co";
var SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml4eWZteGd4ZnB1YXB4dnlvdW15Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg3OTQzNjMsImV4cCI6MjA5NDM3MDM2M30.TmbXrq4mlmOCZBnQYwd4UnFqDBpGCCQNSfMShc14upQ";
export var supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export var BACKEND_URL = "https://syntrix-backend.onrender.com";

export async function callClaude(prompt, maxTokens) {
  var max = maxTokens || 3000;
  var res = await fetch(BACKEND_URL + "/api/claude", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prompt: prompt, maxTokens: max }),
  });
  var data = await res.json();
  if (!res.ok) throw new Error((data && data.error && data.error.message) ? data.error.message : "HTTP " + res.status);
  return (data.content || []).map(function(b) { return b.text || ""; }).join("").trim();
}
